import StepIdentification from '@/febos/chile/dnt/components/wizard/companies/61980520-8/StepIdentification';
import StepInformation from '@/febos/chile/dnt/components/wizard/companies/61980520-8/StepInformation';
import StepFiles from '@/febos/chile/dnt/components/wizard/sharedSteps/StepFiles';

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Identificación',
      component: StepIdentification
    },
    {
      title: 'Información',
      component: StepInformation
    },
    {
      title: 'Documentos relacionados',
      component: StepFiles
    }
  ],
  options: ['submitNumeration', 'draft', 'flow'],
  submitAction: 'saveDocument',
  backupAction: 'saveDocument',
  loadAllData: true,
  wizardMapper(
    {
      dnt,
      observaciones,
      destinatarios,
      adjuntos,
      referencias,
      etiquetas
    }
  ) {
    const data = {};

    if (dnt) {
      data.fileNumber = dnt.numero;
      data.documentType = dnt.emisorCentroCostoNumero || '';
      data.document = dnt.emisorSucursalCodigo || '';
      data.isPrivate = dnt.transportePuertoTipo || '1';
      data.resumen = dnt.nombreDescriptivo;
      data.directionId = dnt.compradorCodigo;
      data.personId = dnt.emisorContactoCodigo;
      data.personPosition = dnt.emisorContactoCargo;
      data.withAttachment = dnt.transporteViaTransporteCodigoTransporte || 0;
      data.documentDetail = dnt.transporteNotas;
      data.creatorGroup = dnt.solicitanteGrupoId;
      data.safiContract = dnt.transportePuertoCodigo;
    }

    if (dnt.solicitanteDocumentoId) {
      data.solicitanteRut = dnt.solicitanteRut;
      data.solicitanteNombre = dnt.solicitanteNombre;
      data.solicitanteEmail = dnt.solicitanteEmail;
      data.solicitanteDocumentoId = dnt.solicitanteDocumentoId;
    }

    if (observaciones && observaciones.length) {
      data.matter = observaciones[0].observacion;
      if (observaciones[1]) {
        data.observation = observaciones[1].observacion;
      }
    }

    if (destinatarios && destinatarios.length) {
      const subjects = destinatarios
        .filter((subject) => subject.tipoDestino.toString() === '1')
        .map((subject) => {
          const subjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            subjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            subject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            subjectEmail: subject.destinoCorreo,
            status: subject.estado,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            subjectTypeDigitalDoc
          };
        });

      data.subjects = [...subjects];
      data.subjectsSelected = [...subjects];

      const copies = destinatarios
        .filter((subject) => subject.tipoDestino.toString() === '2')
        .map((subject) => {
          const copySubjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            copySubjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            copySubject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            copySubjectEmail: subject.destinoCorreo,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            status: subject.estado,
            copySubjectTypeDigitalDoc
          };
        });

      data.copies = [...copies];
      data.copiesSelected = [...copies];
    }

    if (adjuntos && adjuntos.length) {
      const main = adjuntos
        .find((file) => file.tipo === 'principal');

      if (main) {
        data.mainFile = {
          mime: main.adjuntoMime,
          name: main.adjuntoNombre,
          path: main.adjuntoUrl,
          date: main.fecha,
          id: main.adjuntoId,
          currentDescription: main.tipoDescripcion || '',
          status: main.estado || 0
        };
      }

      data.additionalFiles = adjuntos
        .filter((file) => file.tipo === 'adjunto' || file.tipo === 'repositorio')
        .map((file) => ({
          mime: file.adjuntoMime,
          name: file.adjuntoNombre,
          path: file.adjuntoUrl,
          date: file.fecha,
          id: file.adjuntoId,
          ...(file.origen && { origen: file.origen }),
          ...(file.tipo && { tipo: file.tipo }),
          ...(file.archivoId && { archivoId: file.archivoId }),
          currentDescription: file.tipoDescripcion || '',
          status: file.estado || 0
        }));
    }

    if (referencias && referencias.length) {
      if (referencias[0].otraReferenciaId) {
        data.responseFile = true;
      }
      const relatedDocuments = referencias.map((relatedDocument) => ({
        id: relatedDocument.linea,
        type: relatedDocument.tipoDocumento,
        number: relatedDocument.folio,
        otherReferenceId: relatedDocument.otraReferenciaId
      }));

      data.relatedDocuments = [...relatedDocuments];
      data.relatedDocumentsSelected = [...relatedDocuments];
    }

    if (etiquetas && etiquetas.length) {
      data.tags = etiquetas.map((tag) => ({ text: tag.etiqueta }));
    }

    return data;
  },
  documentMapper(input, iutCompany, nameCompany, isDraft = false, isFlow = false) {
    const data = {
      adjuntos: [],
      dnt: {
        tipo: 'EXP',
        emisorRut: iutCompany,
        receptorRut: iutCompany,
        emisorRazonSocial: nameCompany,
        receptorRazonSocial: nameCompany,
        claseMercadoPublico: 'numInt',
        estado: 1,
        emisorCentroCostoNumero: input.documentType,
        emisorCentroCostoNombre: input.documentTypeName,
        emisorSucursalCodigo: input.document,
        emisorSucursalDireccion: input.documentName,
        condicionDespacho: input.formatDocument,
        transportePuertoTipo: input.isPrivate,
        nombreDescriptivo: input.resumen,
        solicitanteGrupoId: input.creatorGroup,
        solicitanteGrupoNombre: input.creatorGroupName,
        compradorCodigo: input.directionId,
        compradorArea: input.directionName,
        emisorContactoCodigo: input.personId,
        emisorContactoNombre: input.personName,
        emisorSucursalCiudad: input.documentOptId,
        emisorSucursalPais: input.documentTypeId,
        emisorContactoCargo: input.personPosition,
        transporteViaTransporteCodigoTransporte: input.withAttachment,
        transporteNotas: input.documentDetail,
        transportePuertoCodigo: input.safiContract
      },
      etiquetas: (input.tags || []).map((tag) => ({
        etiqueta: tag.text
      })),
      destinatarios: [
        ...(input.subjectsSelected || []).map((subject) => {
          const institution = Object.keys(subject.subjectTypeDigitalDoc).length
            ? {
              institucionCodigoId: subject.subjectTypeDigitalDoc.id,
              institucionCodigo: subject.subjectTypeDigitalDoc.value,
              institucionNombre: subject.subjectTypeDigitalDoc.label,
            }
            : {};

          return {
            tipoDestino: 1,
            estado: 1,
            destinoCodigoId: subject.subjectType.id,
            destinoCodigo: subject.subjectType.value,
            destinoNombre: subject.subjectType.label,
            destinoListaCodigoId: subject.subject.id,
            destinoListaCodigo: subject.subject.value,
            destinoListaNombre: subject.subject.label,
            destinoCorreo: subject.subjectEmail,
            providenciaId: subject.providence,
            providenciaVencimiento: subject.providenceExpiration,
            ...institution
          };
        }),
        ...(input.copiesSelected || []).map((subject) => {
          const institution = Object.keys(subject.copySubjectTypeDigitalDoc).length
            ? {
              institucionCodigoId: subject.copySubjectTypeDigitalDoc.id,
              institucionCodigo: subject.copySubjectTypeDigitalDoc.value,
              institucionNombre: subject.copySubjectTypeDigitalDoc.label,
            }
            : {};

          return {
            tipoDestino: 2,
            estado: 1,
            destinoCodigoId: subject.copySubjectType.id,
            destinoCodigo: subject.copySubjectType.value,
            destinoNombre: subject.copySubjectType.label,
            destinoListaCodigoId: subject.copySubject.id,
            destinoListaCodigo: subject.copySubject.value,
            destinoListaNombre: subject.copySubject.label,
            destinoCorreo: subject.copySubjectEmail,
            providenciaId: subject.providence,
            providenciaVencimiento: subject.providenceExpiration,
            ...institution
          };
        })
      ],
      referencias: (input.relatedDocumentsSelected || []).map((relatedDocument) => ({
        linea: relatedDocument.id,
        tipoDocumento: relatedDocument.type,
        folio: relatedDocument.number
      }))
    };

    if (input.solicitanteDocumentoId) {
      data.dnt.solicitanteRut = input.solicitanteRut;
      data.dnt.solicitanteNombre = input.solicitanteNombre;
      data.dnt.solicitanteEmail = input.solicitanteEmail;
      data.dnt.solicitanteDocumentoId = input.solicitanteDocumentoId;
    }

    if (input.matter) {
      data.observaciones = [
        {
          linea: '0',
          observacion: input.matter
        }
      ];
    }

    if (input.observation) {
      data.observaciones.push({
        linea: '1',
        observacion: input.observation
      });
    }

    if (input.mainFile) {
      data.adjuntos = [
        ...data.adjuntos,
        {
          tipo: 'principal',
          adjuntoMime: input.mainFile.mime,
          adjuntoNombre: input.mainFile.name,
          fecha: input.mainFile.date,
          adjuntoUrl: input.mainFile.path,
          tipoDescripcion: input.mainFile.currentDescription,
          ...(input.mainFile.id && { adjuntoId: input.mainFile.id }),
          ...(input.mainFile.status && { estado: input.mainFile.status })
        }
      ];
    }

    if (input.additionalFiles && input.additionalFiles.length) {
      data.adjuntos = [
        ...data.adjuntos,
        ...(input.additionalFiles || []).map((file) => ({
          tipo: file.tipo ? file.tipo : 'adjunto',
          adjuntoMime: file.mime,
          adjuntoNombre: file.name,
          fecha: file.date,
          adjuntoUrl: file.path,
          tipoDescripcion: file.currentDescription,
          ...(file.origen && { origen: file.origen }),
          ...(file.archivoId && { archivoId: file.archivoId }),
          ...(file.id && { adjuntoId: file.id }),
          ...(file.status && { estado: file.status })
        }))
      ];
    }

    if (isDraft) {
      data.dnt.estado = 3;
    }
    if (isFlow) {
      data.dnt.estado = 3;
    }

    return data;
  }
});
